window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['productSoldOutNotifyForm']) return;

  function productSoldOutNotifyForm(data = {}) {
    return {
      ...data,

      isLoadingProductSoldOutForm: false,

      isMarketingEnabled: false,

      isSuccess: false,

      isError: false,

      async onSubmit() {
        if (this.isLoadingProductSoldOutForm) return;

        this.isLoadingProductSoldOutForm = true;
        this.isSuccess = false;
        this.isError = false;

        var formData = new FormData(this.$el);

        this.companyId = formData.get('company_id');
        this.marketingListId = formData.get('marketing_list_id');
        this.firstName = formData.get('first_name');
        this.email = formData.get('email');
        this.variant = formData.get('variant');

        try {
          await this.sendRequest();
          this.isSuccess = true;
        } catch (err) {
          this.isError = true;
        }

        this.isLoadingProductSoldOutForm = false;
      },

      async sendRequest() {
        if (this.isMarketingEnabled && this.marketingListId) {
          this.sendMarketingRequest();
        }

        var url = new URL('https://a.klaviyo.com/client/back-in-stock-subscriptions/');

        url.searchParams.set('company_id', this.companyId);

        var fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-01-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.email,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${this.variant}`,
                  },
                },
              },
            },
          }),
        };

        var res = await fetch(url, fetchOptions);

        if (!res.ok) {
          throw new Error('Back in stock request failed!');
        }
      },

      async sendMarketingRequest() {
        try {
          var url = new URL('https://a.klaviyo.com/client/subscriptions/');

          url.searchParams.set('company_id', this.companyId);

          var fetchOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2025-01-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        first_name: this.firstName,
                        email: this.email,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.marketingListId,
                    },
                  },
                },
              },
            }),
          };

          var res = await fetch(url, fetchOptions);

          if (!res.ok) {
            throw new Error('Marketing request failed');
          }
        } catch (err) {
          this.isError = true;
        }
      }
    };
  };

  Alpine.data('productSoldOutNotifyForm', productSoldOutNotifyForm);

  window.global.registeredAlpineComponents['productSoldOutNotifyForm'] = true;
});
